<template>
  <div>
    <van-nav-bar
      left-arrow
      @click-left="onClickLeft"
      @click-right="deletePetInfo"
    >
      <template #left>
        <img
          src="../assets/img/pet-info/editinfo-left-icon.png"
          alt=""
        />
      </template>
      <template #title>
        <a href="https://pawaiipets.com">
          <img
            src="../assets/img/pet-info/pawaii-logo.png"
            alt=""
          />
        </a>
      </template>
      <template #right>
        <img
          src="../assets/img/pet-info/petinfo-delete-icon.png"
          alt=""
        />
      </template>
    </van-nav-bar>
    <div
      class="cropper-content"
      v-if="showPetInfoImgCropper"
    >
      <div class="cropper-box-content">
        <div class="cropper">
          <vue-cropper
            ref="cropper"
            :img="pwoption.img"
            :outputSize="pwoption.outputSize"
            :outputType="pwoption.outputType"
            :info="pwoption.info"
            :canScale="pwoption.canScale"
            :autoCrop="pwoption.autoCrop"
            :autoCropWidth="pwoption.autoCropWidth"
            :autoCropHeight="pwoption.autoCropHeight"
            :fixed="pwoption.fixed"
            :fixedNumber="pwoption.fixedNumber"
            :full="pwoption.full"
            :fixedBox="pwoption.fixedBox"
            :canMove="pwoption.canMove"
            :canMoveBox="pwoption.canMoveBox"
            :original="pwoption.original"
            :centerBox="pwoption.centerBox"
            :height="pwoption.height"
            :infoTrue="pwoption.infoTrue"
            :maxImgSize="pwoption.maxImgSize"
            :enlarge="pwoption.enlarge"
            :mode="pwoption.mode"
          >
          </vue-cropper>
          <!--底部操作工具按钮-->
          <div class="footer-btn">
            <div class="upload-btn">
              <div
                class="upload-btn-cancel"
                @click="clearCrop"
              >Cancel</div>
              <div
                class="upload-btn-confirm"
                @click="uploadImg('blob')"
              >Confirm</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-tabs
      v-model="active"
      type="card"
      v-if="showOldVersions"
    >
      <van-form ref="petIndoForm">
        <van-tab title="Pet’s Information">
          <!-- 图片编辑占位 -->
          <div class="petinfo-img">
            <img
              v-if="petSelectData.photo"
              :src="'https://finder.pawaiipets.com' + petSelectData.photo"
              alt=""
            />
            <img
              v-else
              src="https://finder.pawaiipets.com/static/blank.png"
            />
          </div>
          <div class="petinfo-upload-icon btn">
            <label
              class="btn"
              for="uploads"
            >
            </label>
            <input
              type="file"
              id="uploads"
              style="position:absolute; clip:rect(0 0 0 0);"
              accept="image/png, image/jpeg, image/jpg"
              @change="selectImg($event)"
            >
          </div>
          <div class="petinfo-content">
            <div class="petinfo-content-title">Pet's information</div>
            <div class="petinfo-content-item-title"><span>*</span> Pet's name</div>
            <van-field
              v-model="petSelectData.pet_name"
              name="User name"
              autocomplete="off"
              :rules="[{ required: true, message: 'Please enter user name' }]"
            />

            <div class="petinfo-content-item-title"><span>*</span> Species</div>
            <van-field
              readonly
              clickable
              name="picker"
              :value="petSelectData.species1"
              :rules="[{ required: true, message: 'Click to choose species' }]"
              @click="showSpeciesPicker = true"
            />
            <van-popup
              v-model="showSpeciesPicker"
              position="bottom"
            >
              <van-picker
                show-toolbar
                :columns="speciesData"
                @confirm="onSpeciesConfirm"
                @cancel="showSpeciesPicker = false"
              />
            </van-popup>
            <van-field
              v-model="petSelectData.species2"
              name="Species"
              :rules="[{ required: true, message: 'Please enter species' }]"
              autocomplete="off"
              v-if="showSpeciesInput"
            />

            <div class="petinfo-content-item-title"><span>*</span> Breed</div>
            <van-field
              readonly
              clickable
              name="breed"
              :value="petSelectData.breed1"
              :rules="[{ required: true, message: 'Click to choose breed' }]"
              @click="showBreedPicker = true"
              v-if="showBreedSelect"
            />
            <van-popup
              v-model="showBreedPicker"
              position="bottom"
            >
              <van-picker
                show-toolbar
                :columns="breeData"
                @confirm="onBreedConfirm"
                @cancel="showBreedPicker = false"
              />
            </van-popup>
            <van-field
              v-model="petSelectData.breed2"
              name="Breed"
              :rules="[{ required: true, message: 'Please enter breed' }]"
              autocomplete="off"
              v-if="showBreedInput"
            />

            <div class="petinfo-content-item-title"><span>*</span> Gender</div>
            <van-field
              readonly
              clickable
              name="gender"
              :value="petSelectData.gender"
              :rules="[{ required: true, message: 'Click Select' }]"
              @click="showGenderPicker = true"
            />
            <van-popup
              v-model="showGenderPicker"
              position="bottom"
            >
              <van-picker
                show-toolbar
                :columns="genderData"
                @confirm="onGenderConfirm"
                @cancel="showGenderPicker = false"
              />
            </van-popup>

            <div class="petinfo-content-item-title"><span>*</span> Age</div>
            <div class="petinfo-content-age">
              <van-field
                readonly
                clickable
                name="years"
                :value="petSelectData.age1"
                :rules="[{ required: true, message: 'Click Select' }]"
                @click="showYearsPicker = true"
                class="petinfo-content-age-year"
              />
              <van-popup
                v-model="showYearsPicker"
                position="bottom"
              >
                <van-picker
                  show-toolbar
                  :columns="yearsData"
                  @confirm="onYearsConfirm"
                  @cancel="showYearsPicker = false"
                />
              </van-popup>

              <van-field
                readonly
                clickable
                name="months"
                :value="petSelectData.age2"
                :rules="[{ required: true, message: 'Click Select' }]"
                @click="showMonthsPicker = true"
                class="petinfo-content-age-months"
              />
              <van-popup
                v-model="showMonthsPicker"
                position="bottom"
              >
                <van-picker
                  show-toolbar
                  :columns="monthsData"
                  @confirm="onMonthsConfirm"
                  @cancel="showMonthsPicker = false"
                />
              </van-popup>
            </div>

            <div class="petinfo-content-item-title">Weight (optional)</div>
            <van-field
              v-model="petSelectData.weight"
              name="weight"
              autocomplete="off"
              placeholder="weight"
            />

            <!-- <div class="petinfo-content-item-title">What did you buy</div>
            <van-field
              readonly
              clickable
              name="buy"
              :value="petSelectData.buy_type"
              :rules="[{ required: true, message: 'Click Select' }]"
              autocomplete="off"
              @click="showBuytypePicker = true"
            />
            <van-popup v-model="showBuytypePicker" position="bottom">
              <van-picker
                show-toolbar
                :columns="buytypeData"
                @confirm="onBuytypeConfirm"
                @cancel="showBuytypePicker = false"
              />
            </van-popup> -->

            <div class="petinfo-content-item-title">
              Eating habits (optional)
            </div>
            <van-field
              v-model="petSelectData.habit"
              rows="5"
              autosize
              type="textarea"
              placeholder="Enter your message"
              show-word-limit
              class="petinfo-content-textarea"
            />
            <div class="petinfo-content-item-title">
              Allergic history (optional)
            </div>
            <van-field
              v-model="petSelectData.allergic"
              rows="5"
              autosize
              type="textarea"
              placeholder="Enter your message"
              show-word-limit
              class="petinfo-content-textarea"
            />
            <div class="petinfo-content-item-title">
              Medical History (optional)
            </div>
            <van-field
              v-model="petSelectData.medical"
              rows="5"
              autosize
              type="textarea"
              placeholder="Enter your message"
              show-word-limit
              class="petinfo-content-textarea"
            />
          </div>
        </van-tab>
        <van-tab
          class="ownerinfo-content"
          title="Owner’s Information"
        >
          <div class="ownerinfo-content-title">Owner's information</div>
          <div class="ownerinfo-content-item-title"><span>*</span> Full name</div>
          <van-field
            v-model="petSelectData.own_name"
            name="username"
            autocomplete="off"
            :rules="[{ required: true, message: 'Please enter fullname' }]"
          />

          <div class="ownerinfo-content-item-title"><span>*</span> Phone</div>
          <van-field
            v-model="petSelectData.phone"
            name="phone"
            autocomplete="off"
            :rules="[{ required: true, message: 'Please enter phone' }]"
          />

          <div class="ownerinfo-content-item-title"><span>*</span> Family Member</div>
          <van-field
            readonly
            clickable
            name="Family Member"
            :value="petSelectData.family_member"
            :rules="[{ required: true, message: 'Click Select' }]"
            @click="showFamilyMemberPicker = true"
          />
          <van-popup
            v-model="showFamilyMemberPicker"
            position="bottom"
          >
            <van-picker
              show-toolbar
              :columns="familyMemberData"
              @confirm="onFamilyMemberConfirm"
              @cancel="showFamilyMemberPicker = false"
            />
          </van-popup>

          <div class="ownerinfo-content-item-title"><span>*</span> Country/Region</div>
          <van-field
            readonly
            clickable
            name="country"
            :value="petSelectData.country1"
            :rules="[{ required: true, message: 'Click Select' }]"
            @click="showCountryPicker = true"
            v-show="showCountrySelect"
          />
          <van-popup
            v-model="showCountryPicker"
            position="bottom"
            v-show="showCountrySelect"
          >
            <van-picker
              show-toolbar
              :columns="countryData"
              @confirm="onCountryConfirm"
              @cancel="showCountryPicker = false"
            />
          </van-popup>
          <van-field
            v-model="petSelectData.country2"
            name="country1"
            autocomplete="off"
            :rules="[{ required: true, message: 'Please enter country' }]"
            v-if="showCountryInput"
          />
          <div class="ownerinfo-content-item-title">Address (optional)</div>
          <van-field
            v-model="petSelectData.address1"
            name="address1"
            placeholder="address1"
            autocomplete="off"
            class="ownerinfo-content-item-address-top"
          />
          <van-field
            v-model="petSelectData.address2"
            name="address2"
            placeholder="address2"
            autocomplete="off"
            class="ownerinfo-content-item-address-bottom"
          />
          <div class="ownerinfo-content-item-title"><span>*</span> City</div>
          <van-field
            v-model="petSelectData.city"
            name="city"
            placeholder="city"
            autocomplete="off"
          />
          <div class="ownerinfo-content-detailedly">
            <div class="ownerinfo-content-detailedly-item">
              <div class="ownerinfo-content-item-title"><span>*</span> State</div>
              <van-field
                readonly
                clickable
                name="State1"
                :value="petSelectData.state1"
                placeholder="State"
                @click="showStatePicker = true"
                v-show="!showCountryInput"
                autocomplete="off"
              />
              <van-popup
                v-model="showStatePicker"
                position="bottom"
              >
                <van-picker
                  show-toolbar
                  :columns="stateData"
                  @confirm="onStateConfirm"
                  @cancel="showStatePicker = false"
                />
              </van-popup>
              <van-field
                v-model="petSelectData.state2"
                name="state2"
                placeholder="state"
                autocomplete="off"
                v-if="showCountryInput"
              />
            </div>
            <div class="ownerinfo-content-detailedly-item">
              <div class="ownerinfo-content-item-title">
                ZIP code (optional)
              </div>
              <van-field
                name="ZIP1"
                v-model="petSelectData.zip1"
                placeholder="ZIP"
                v-show="!showCountryInput"
              />
              <van-field
                name="ZIP2"
                v-model="petSelectData.zip2"
                placeholder="ZIP"
                v-show="showCountryInput"
              />
            </div>
          </div>
          <div class="ownerinfo-content-item-title">Message (optional)</div>
          <van-field
            v-model="petSelectData.message"
            rows="5"
            autosize
            type="textarea"
            placeholder="Enter your message"
            show-word-limit
          />
        </van-tab>
        <div class="petinfo-save-button">
          <van-button
            type="danger"
            @click="editPetSave"
          >Save</van-button>
        </div>
      </van-form>
    </van-tabs>

    <van-tabs
      v-model="active"
      type="card"
      class="pw-petinfoshow-new"
      v-if="showNewVersions"
    >
      <van-form ref="petIndoForm">
        <!-- 图片编辑占位 -->
        <div class="petinfo-img">
          <img
            v-if="petSelectData.photo"
            :src="'https://finder.pawaiipets.com' + petSelectData.photo"
            alt=""
          />
          <img
            v-else
            src="https://finder.pawaiipets.com/static/blank.png"
          />
        </div>
        <div class="petinfo-upload-icon btn">
          <label
            class="btn"
            for="uploads"
          >
          </label>
          <input
            type="file"
            id="uploads"
            style="position:absolute; clip:rect(0 0 0 0);"
            accept="image/png, image/jpeg, image/jpg"
            @change="selectImg($event)"
          >
        </div>
        <div class="petinfo-content">
          <div class="petinfo-content-item-title"><span>*</span> Pet's name</div>
          <van-field
            v-model="petSelectData.pet_name"
            name="User name"
            autocomplete="off"
            :rules="[{ required: true, message: 'Please enter user name' }]"
          />

          <div class="petinfo-content-item-title"><span>*</span> Species</div>
          <van-field
            readonly
            clickable
            name="picker"
            class="pw-mobile-input"
            :value="petSelectData.species1"
            :rules="[{ required: true, message: 'Click to choose species' }]"
            @click="showSpeciesPicker = true"
          />
          <van-popup
            v-model="showSpeciesPicker"
            position="bottom"
          >
            <van-picker
              show-toolbar
              :columns="speciesData"
              @confirm="onNewSpeciesConfirm"
              @cancel="showSpeciesPicker = false"
            />
          </van-popup>
          <van-field
            v-model="petSelectData.species2"
            name="Species"
            :rules="[{ required: true, message: 'Please enter species' }]"
            autocomplete="off"
            v-if="showSpeciesInput"
          />

          <div class="petinfo-content-item-title"><span>*</span> Breed</div>
          <van-field
            readonly
            clickable
            name="breed"
            class="pw-mobile-input"
            :value="petSelectData.breed1"
            :rules="[{ required: true, message: 'Click to choose breed' }]"
            @click="newShowBreedPicker = true"
            v-if="showBreedSelect"
          />
          <van-popup
            v-model="newShowBreedPicker"
            position="bottom"
          >
            <van-picker
              show-toolbar
              :columns="petBreedDataDog_Cat"
              value-key="breed_us"
              @confirm="onNewBreedConfirm"
              @cancel="newShowBreedPicker = false"
            />
          </van-popup>

          <van-field
            readonly
            clickable
            name="breed"
            class="pw-mobile-input"
            :value="petSelectData.option"
            :rules="[{ required: true, message: 'Click to choose option' }]"
            @click="showOptionPicker = true"
            v-if="showOptionField"
          />
          <van-popup
            v-model="showOptionPicker"
            position="bottom"
          >
            <van-picker
              show-toolbar
              :columns="petBreedDataDog_Catthree"
              value-key="option_us"
              @confirm="onNewOptionConfirm"
              @cancel="showOptionPicker = false"
            />
          </van-popup>

          <van-field
            v-model="petSelectData.breed2"
            name="Breed"
            :rules="[{ required: true, message: 'Please enter breed' }]"
            autocomplete="off"
            v-if="showBreedInput"
          />
          <div class="petinfo-content-item-title"><span>*</span> Birthday</div>
          <div class="pw-birthday-selects">

            <van-field
              readonly
              clickable
              name="birthdayYear"
              class="pw-mobile-input"
              :value="petSelectData.birthday"
              @click="showBirthdaySelect = true"
              v-if="showBirthdaySelectInput"
            />
            <van-popup
              v-model="showBirthdaySelect"
              position="bottom"
            >
              <van-datetime-picker
                v-if="showBirthdaySelect"
                type="date"
                name="PetinfoBirthday"
                @confirm="onPetinfoBirthdayConfirm"
                @cancel="showBirthdaySelect = false"
                :min-date="minDate"
                :max-date="maxDate"
              />
            </van-popup>
          </div>
          <div class="ownerinfo-content-item-title"><span>*</span> Phone</div>
          <van-field
            v-model="petSelectData.phone"
            name="phone"
            autocomplete="off"
            :rules="[{ required: true, message: 'Please enter phone' }]"
          />

          <div class="petinfo-content-item-title">Weight</div>
          <div class="pw-petinfo-weight">
            <van-field
              v-model="petSelectData.weight"
              type="number"
              name="weight"
              autocomplete="off"
              placeholder="weight"
            />

            <van-field
            
              readonly
              clickable
              name="weight"
              class="pw-mobile-input"
              :value="petSelectData.unit"
              @click="showWeightUnit = true"
              v-if="showWeightUnitSelect"
            />
            <van-popup
              v-model="showWeightUnit"
              position="bottom"
            >
              <van-picker
                show-toolbar
                :columns="weightData"
                @confirm="onWeightConfirm"
                @cancel="showWeightUnit = false"
              />
            </van-popup>
          </div>
          <div class="ownerinfo-content-item-title">Country/Region</div>
          <van-field
            readonly
            clickable
            name="country"
            class="pw-mobile-input"
            :value="petSelectData.country1"
            :rules="[{ required: true, message: 'Click Select' }]"
            @click="showCountryPicker = true"
            v-show="showCountrySelect"
          />
          <van-popup
            v-model="showCountryPicker"
            position="bottom"
            v-show="showCountrySelect"
          >
            <van-picker
              show-toolbar
              :columns="petCounrtyData"
              @confirm="onNewCountryConfirm"
              @cancel="showCountryPicker = false"
            />
          </van-popup>
          <van-field
            v-model="petSelectData.country2"
            name="country1"
            autocomplete="off"
            :rules="[{ required: true, message: 'Please enter country' }]"
            v-if="showCountryInput"
          />
          <div class="ownerinfo-content-item-title">Address (optional)</div>
          <van-field
            v-model="petSelectData.address1"
            name="address1"
            placeholder="address1"
            autocomplete="off"
            class="ownerinfo-content-item-address-top"
          />
          <van-field
            v-model="petSelectData.address2"
            name="address2"
            placeholder="address2"
            autocomplete="off"
            class="ownerinfo-content-item-address-bottom"
          />
          <div class="ownerinfo-content-item-title">City</div>
          <van-field
            v-model="petSelectData.city"
            name="city"
            placeholder="city"
            autocomplete="off"
          />
          <div class="ownerinfo-content-detailedly">
            <div class="ownerinfo-content-detailedly-item ownerinfo-content-detailedly-item-state">
              <div class="ownerinfo-content-item-title">State</div>
              <van-field
                class="pw-mobile-input"
                readonly
                clickable
                name="State1"
                :value="petSelectData.state1"
                placeholder="State"
                @click="showStatePicker = true"
                v-show="!showNewCountryInput"
                autocomplete="off"
              />
              <van-popup
                v-model="showStatePicker"
                position="bottom"
              >
                <van-picker
                  show-toolbar
                  :columns="stateData"
                  @confirm="onStateConfirm"
                  @cancel="showStatePicker = false"
                />
              </van-popup>
              <van-field
                v-model="petSelectData.state2"
                name="state2"
                placeholder="state"
                autocomplete="off"
                v-if="showNewCountryInput"
              />
            </div>
            <div class="ownerinfo-content-detailedly-item">
              <div class="ownerinfo-content-item-title">
                ZIP code
              </div>
              <van-field
                name="ZIP1"
                v-model="petSelectData.zip1"
                placeholder="ZIP"
                v-show="!showCountryInput"
              />
              <van-field
                name="ZIP2"
                v-model="petSelectData.zip2"
                placeholder="ZIP"
                v-show="showCountryInput"
              />
            </div>
          </div>
          <div class="ownerinfo-content-item-title">Message</div>
          <van-field
            v-model="petSelectData.message"
            rows="5"
            autosize
            type="textarea"
            placeholder="Enter your message"
            show-word-limit
          />
        </div>

        <div class="petinfo-save-button">
          <van-button
            type="danger"
            @click="editPetSave"
          >Save</van-button>
        </div>
      </van-form>
    </van-tabs>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../components/children/Footer.vue";
export default {
  name: "Pet",
  components: {
    Footer,
  },
  data() {
    return {
      // 当前选择宠物的数据
      petSelectData: {},
      // 新版获取国家数据
      petCounrtyData: [],
      // 新版获取宠物分类数据
      petBreedData: {},

      //数据判断
      petBreedDataDog_Cat: {},
      petBreedDataDog_Catthree: {},

      //生日选择
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(),
      //生日默认不展示下拉框
      showBirthdaySelect: false,
      showBirthdaySelectInput: true,
      //新版二级宠物种类选择
      showOptionPicker: false,
      //二级宠物种类选择框展示
      showOptionField: false,

      // 图片插件数据
      pwoption: {
        img: "", //裁剪图片的地址
        outputSize: 1, //裁剪生成图片的质量(可选0.1 - 1)
        outputType: "jpeg", //裁剪生成图片的格式（jpeg || png || webp）
        info: true, //图片大小信息
        canScale: true, //图片是否允许滚轮缩放
        autoCrop: true, //是否默认生成截图框
        autoCropWidth: 335, //默认生成截图框宽度
        autoCropHeight: 335, //默认生成截图框高度
        fixed: true, //是否开启截图框宽高固定比例
        fixedNumber: [1, 1], //截图框的宽高比例
        full: false, //false按原比例裁切图片，不失真
        fixedBox: true, //固定截图框大小，不允许改变
        canMove: false, //上传图片是否可以移动
        canMoveBox: true, //截图框能否拖动
        original: false, //上传图片按照原始比例渲染
        centerBox: true, //截图框是否被限制在图片里面
        height: true, //是否按照设备的dpr 输出等比例图片
        infoTrue: false, //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 2000, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: "335px 335px", //图片默认渲染方式
      },
      // 插件展示
      showPetInfoImgCropper: false,

      // Tab栏默认展示
      active: 0,
      // 弹出层显示控制
      showSpeciesPicker: false,
      showGenderPicker: false,
      showYearsPicker: false,
      showMonthsPicker: false,
      // showBuytypePicker: false,
      showFamilyMemberPicker: false,
      showCountryPicker: false,
      showStatePicker: false,
      // species数据
      speciesData: ["dog", "cat", "other"],
      // breed弹出层显示
      showBreedPicker: false,
      // 新版breed弹出层显示
      newShowBreedPicker: false,
      // breeddog数据
      breedDogData: [
        "Non-pedigree",
        "Retrievers (Labrador)",
        "German Shepherd Dogs",
        "Retrievers (Golden)",
        "French Bulldogs",
        "Bulldogs",
        "Poodles",
        "Beagles",
        "Rottweilers",
        "Pointers (German Shorthaired)",
        "Pembroke Welsh Corgis",
        "Dachshunds",
        "Yorkshire Terriers",
        "Australian Shepherds",
        "Boxers",
        "Siberian Huskies",
        "Cavalier King Charles Spaniels",
        "Great Danes",
        "Miniature Schnauzers",
        "Doberman Pinschers",
        "Shih Tzu",
        "Boston Terriers",
        "Havanese",
        "Bernese Mountain Dogs",
        "Pomeranians",
        "Shetland Sheepdogs",
        "Brittanys",
        "Spaniels (English Springer)",
        "Spaniels (Cocker)",
        "Miniature American Shepherds",
        "Cane Corso",
        "Pugs",
        "Mastiffs",
        "Border Collies",
        "Vizslas",
        "Chihuahuas",
        "Maltese",
        "Basset Hounds",
        "Collies",
        "Weimaraners",
        "Newfoundlands",
        "Belgian Malinois",
        "Rhodesian Ridgebacks",
        "Bichons Frises",
        "West Highland White Terriers",
        "Shiba Inu",
        "Retrievers (Chesapeake Bay)",
        "Akitas",
        "St. Bernards",
        "Portuguese Water Dogs",
        "Spaniels (English Cocker)",
        "Other",
      ],
      // breedcat数据
      breedCatData: [
        "Non-pedigree",
        "Abyssinian",
        "American Shorthair",
        "Bengal",
        "Birman",
        "Bombay",
        "British Shorthair",
        "Burmese",
        "Burmilla",
        "Chartreux",
        "Devon Rex",
        "Exotic Shorthair",
        "Himalayan",
        "Maine Coon",
        "Nebelung",
        "Norwegian Forest",
        "Oriental Shorthair",
        "Persian",
        "Ragamuffin",
        "Ragdoll",
        "Russian Blue",
        "Scottish Fold",
        "Siamese",
        "Siberian",
        "Snowshoe cat",
        "Sphynx",
        "Tonkinese",
        "Turkish Angora",
        "Turkish Van",
        "Other",
      ],
      // 由species决定的breed数据
      breeData: [],

      // 控制input框
      showSpeciesInput: "",
      showBreedSelect: "",
      showBreedInput: "",
      showCountryInput: "",
      // gender 数据
      genderData: ["Male", "Female", "No answer"],
      // years数据
      yearsData: [
        "0 Years",
        "1 Year",
        "2 Years",
        "3 Years",
        "4 Years",
        "5 Years",
        "6 Years",
        "7 Years",
        "8 Years",
        "9 Years",
        "10 Years",
        "11 Years",
        "12 Years",
        "13 Years",
        "14 Years",
        "15 Years",
        "16 Years",
        "17 Years",
        "18 Years",
        "19 Years",
        "20 Years",
        "21 Years",
        "22 Years",
        "23 Years",
        "24 Years",
        "25 Years",
        "26 Years",
        "27 Years",
        "28 Years",
        "29 Years",
        "30 Years",
        "31 Years",
      ],
      // months数据
      monthsData: [
        "0 Months",
        "1 Month",
        "2 Months",
        "3 Months",
        "4 Months",
        "5 Months",
        "6 Months",
        "7 Months",
        "8 Months",
        "9 Months",
        "10 Months",
        "11 Months",
        "12 Months",
      ],
      // buytype数据
      buytypeData: ["Harness", "Collar"],
      // family数据
      familyMemberData: ["Dad", "Mom", "Brother", "Sister"],
      // country数据
      countryData: ["United States", "Other countries and regions"],
      // state数据
      stateData: [
        "Washington District of Columbia",
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
        "American Samoa",
        "Guam",
        "Puerto Rico",
        "Northern Marianas",
        "U.S. Virgin Islands",
      ],
      // 显示版本判断
      showOldVersions: true,
      showNewVersions: false,
      //体重单位控制input框展示
      showWeightUnitSelect: true,
      //体重单位控制下拉框框展示
      showWeightUnit: false,
      //体重单位数据
      weightData: ["Kg", "Lb"],
      // 新版展示城市填写框
      showNewCountryInput: true,
    };
  },
  created() {
    //当前宠物数据
    this.petSelectData = JSON.parse(
      window.sessionStorage.getItem("usersSelectInfo")
    );
    //获取国家数据
    this.getPetInfoState();
    //获取宠物种类数据
    this.getPetInfoBreed();

    //显示版本判断
    if (this.petSelectData.old_code == 1) {
      this.showNewVersions = false;
      this.showOldVersions = true;
      if (this.petSelectData.country1 === "United States") {
        this.showCountrySelect = true;
        this.showCountryInput = false;
      } else {
        this.showCountrySelect = true;
        this.showCountryInput = true;
      }
    } else {
      this.showNewVersions = true;
      this.showOldVersions = false;
      if (this.petSelectData.country1 === "United States") {
        this.showCountrySelect = true;
        this.showCountryInput = false;
        this.showNewCountryInput = false;
      } else {
        this.showCountrySelect = true;
        this.showCountryInput = false;
        this.showNewCountryInput = true;
      }
    }
    // 初始化数据
    if (this.petSelectData.species1 === "dog") {
      this.breeData = this.breedDogData;
      this.showBreedInput = false;
      this.showBreedSelect = true;
    }
    if (this.petSelectData.species1 === "cat") {
      this.breeData = this.breedCatData;
      this.showBreedInput = false;
      this.showBreedSelect = true;
    }
    if (this.petSelectData.species1 === "other") {
      this.showSpeciesInput = true;
      this.showBreedInput = true;
      this.showBreedSelect = false;
    }
    if (
      this.petSelectData.species1 !== "other" &&
      this.petSelectData.breed1 === "Other"
    ) {
      this.showSpeciesInput = false;
      this.showBreedInput = true;
      this.showBreedSelect = true;
    }
    if (
      this.petSelectData.species1 !== "other" &&
      this.petSelectData.breed1 !== "Other"
    ) {
      this.showSpeciesInput = false;
      this.showBreedInput = false;
      this.showBreedSelect = true;
    }
    if (this.petSelectData.gender === 1) {
      this.petSelectData.gender = "Male";
    } else if (this.petSelectData.gender === 2) {
      this.petSelectData.gender = "Female";
    } else {
      this.petSelectData.gender = "No answer";
    }

    if (this.petSelectData.option !== "") {
      this.showOptionField = true;
    }

    if (this.petSelectData.birthday != null) {
      this.petSelectData.birthday = this.petSelectData.birthday.split(" ")[0];
    }
    //生日日期处理
    this.timeFormat(new Date());
  },
  methods: {
    //生日改变选择
    onPetinfoBirthdayConfirm(value) {
      this.petSelectData.birthday = this.timeFormat(value);
      this.showBirthdaySelect = false;
    },
    timeFormat(time) {
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    // // 图片上传处理
    // beforeRead(file) {
    //   const isType = file.type === "image/jpeg" || file.type === "image/png";
    //   if (!isType) {
    //     this.$toast("Only JPG. PNG. file types are allowed");
    //     return false;
    //   }
    //   return true;
    // },
    // async Uploader(file) {
    //   // 此时可以自行将文件上传至服务器
    //   const formData = new FormData();
    //   formData.append("file", file.file);
    //   const { data: res } = await this.$http.post("/upload", formData);
    //   if (res.status !== 200) return this.$toast("Failed to upload");
    //   this.petSelectData.photo = res.url;
    // },
    // // 上传图片展示裁剪框
    // handleClickshowCropper() {
    //   this.showPetInfoImgCropper = true;
    // },
    //获取城市、州数据
    async getPetInfoState() {
      // var newData = [];
      const { data: res } = await this.$http.get("/countrys");
      if (res.status !== 200) return;
      res.data.map((value) => {
        this.petCounrtyData.push(value.country);
      });
    },
    //获取宠物种类数据
    async getPetInfoBreed() {
      // var newData = [];
      const { data: res } = await this.$http.get("/breeds");
      if (res.status !== 200) return;
      this.petBreedData = res.data;
      //渲染一级分类  
      if (this.petSelectData.species1 == "dog") {
        this.petBreedDataDog_Cat = this.petBreedData.dog;
      }
      if (this.petSelectData.species1 == "cat") {
        this.petBreedDataDog_Cat = this.petBreedData.cat;
      }
      //渲染二级分类
      for (let i = 0; i < this.petBreedDataDog_Cat.length; i++) {
        if (
          this.petBreedDataDog_Cat[i].breed_us == this.petSelectData.breed1
        ) {
          if (this.petBreedDataDog_Cat[i].option == null) {
            this.showOptionField = false;
          } else {
            this.showOptionField = true;
            this.petBreedDataDog_Catthree = this.petBreedDataDog_Cat[i].option;
          }
        }
      }
    },

    //选择图片
    selectImg(e) {
      let file = e.target.files[0];
      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
        this.$message({
          message: "Only JPG. PNG. file types are allowed",
          type: "error",
        });
        this.showPetInfoImgCropper = false;
        return false;
      } else {
        this.showPetInfoImgCropper = true;
      }
      //转化为blob
      let reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.pwoption.img = data;
      };
      //转化为base64
      reader.readAsDataURL(file);
    },
    //上传图片
    uploadImg(type) {
      let _this = this;
      if (type === "blob") {
        //获取截图的blob数据
        this.$refs.cropper.getCropBlob(async (data) => {
          let formData = new FormData();
          formData.append("file", data, "image.jpg");
          let { data: res } = await _this.$http.post("/upload", formData);
          if (res.status === 200) {
            _this.$message({
              message: "success",
              type: "success",
            });
            this.petSelectData.photo = res.url;
            _this.$emit("uploadImgSuccess", res);
          } else {
            _this.$message({
              message: "error",
              type: "error",
            });
          }
          this.showPetInfoImgCropper = false;
        });
      }
    },
    //清除动画
    clearCrop() {
      this.$refs.cropper.clearCrop();
      (this.pwoption.img = ""), (this.showPetInfoImgCropper = false);
    },

    // species选择框确认
    onSpeciesConfirm(value) {
      if (this.petSelectData.species1 !== value) {
        this.petSelectData.breed1 = "";
      }
      this.petSelectData.species1 = value;
      this.showSpeciesPicker = false;
      if (value === "dog") {
        this.showSpeciesInput = false;
        this.showBreedInput = false;
        this.showBreedSelect = true;
        this.breeData = this.breedDogData;
      }
      if (value === "cat") {
        this.showSpeciesInput = false;
        this.showBreedInput = false;
        this.showBreedSelect = true;
        this.breeData = this.breedCatData;
      }
      if (value === "other") {
        this.showSpeciesInput = true;
        this.showBreedInput = true;
        this.showBreedSelect = false;
        this.showOptionField = false;
      }
    },
    // breed选择框确认
    onBreedConfirm(value) {
      this.petSelectData.breed1 = value;
      this.showBreedPicker = false;
      if (value === "Other") {
        this.showBreedInput = true;
        this.showBreedSelect = true;
      } else {
        this.showBreedInput = false;
        this.showBreedSelect = true;
      }
    },

    // 新版species选择框确认
    onNewSpeciesConfirm(value) {
      this.petSelectData.species1 = value;
      this.showSpeciesPicker = false;
      this.petSelectData.breed1 = "";
      this.petSelectData.breed2 = "";
      this.petSelectData.species2 = "";
      this.petSelectData.option = "";
      this.showOptionField = false;
      if (value === "dog") {
        this.showSpeciesInput = false;
        this.showBreedInput = false;
        this.showBreedSelect = true;
        this.petBreedDataDog_Cat = this.petBreedData.dog;
      }
      if (value === "cat") {
        this.showSpeciesInput = false;
        this.showBreedInput = false;
        this.showBreedSelect = true;
        this.petBreedDataDog_Cat = this.petBreedData.cat;
      }
      if (value === "other") {
        this.showSpeciesInput = true;
        this.showBreedInput = true;
        this.showBreedSelect = false;
        this.showOptionField = false;
      }
    },
    //新版breed选择框确认
    onNewBreedConfirm(value) {
      this.petSelectData.breed1 = value.breed_us;
      this.petSelectData.option = "";

      if (value.option != null) {
        this.showOptionField = true;
        this.petBreedDataDog_Catthree = value.option;
      } else {
        this.showOptionField = false;
      }
      this.newShowBreedPicker = false;
    },
    //新版二级分类选择
    onNewOptionConfirm(value) {
      this.petSelectData.option = value.option_us;
      this.showOptionPicker = false;
    },

    // gender选择框确认
    onGenderConfirm(value) {
      this.petSelectData.gender = value;
      this.showGenderPicker = false;
    },

    // 体重单位确认
    onWeightConfirm(value) {
      this.petSelectData.unit = value;
      this.showWeightUnit = false;
    },
    // 年选择框确认
    onYearsConfirm(value) {
      this.petSelectData.age1 = value;
      this.showYearsPicker = false;
    },
    // 月选择框确认
    onMonthsConfirm(value) {
      this.petSelectData.age2 = value;
      this.showMonthsPicker = false;
    },
    // buytype选择框确认
    onBuytypeConfirm(value) {
      this.petSelectData.buy_type = value;
      // this.showBuytypePicker = false;
    },
    // familymember选择框确认
    onFamilyMemberConfirm(value) {
      this.petSelectData.family_member = value;
      this.showFamilyMemberPicker = false;
    },
    // country选择框确认
    onCountryConfirm(value) {
      this.showCountrySelect = true;
      this.petSelectData.country1 = value;
      this.showCountryPicker = false;
      if (value === "Other countries and regions") {
        this.showCountryInput = true;
      } else {
        this.showCountryInput = false;
      }
    },
    // 新版country选择框确认
    onNewCountryConfirm(value) {
      this.showCountryInput = false;
      this.petSelectData.country1 = value;
      this.showCountryPicker = false;
      if (value == "United States") {
        this.showNewCountryInput = false;
      } else {
        this.showNewCountryInput = true;
      }
    },
    // state选择框确认
    onStateConfirm(value) {
      this.petSelectData.state1 = value;
      this.showStatePicker = false;
    },
    // 保存
    editPetSave() {
      this.$refs.petIndoForm
        .validate()
        .then(async () => {
          if (this.petSelectData.gender === "Male") {
            this.petSelectData.gender = 1;
          }
          if (this.petSelectData.gender === "Female") {
            this.petSelectData.gender = 2;
          }
          if (this.petSelectData.gender === "No answer") {
            this.petSelectData.gender = 3;
          }
          if (this.petSelectData.country2 === "Other countries and regions") {
            this.petSelectData.gender = "Other";
          }
          const { data: res } = await this.$http.put(
            "/pet",
            this.petSelectData
          );
          if (res.status !== 200) return this.$toast.fail("Failed to save");
          this.$toast.success("Saved");
          this.$router.push({ path: "/home" });
        })
        .catch(() => {
          this.$toast.fail("Please fill in the complete information");
        });
    },
    // 删除操作
    async deletePetInfo() {
      const confirmRes = await this.$dialog
        .confirm({
          messageAlign: "left",
          confirmButtonText: "Confirm",
          confirmButtonColor: "#FF5349",
          cancelButtonText: "Cancel",
          cancelButtonColor: "#999",
          // theme:'round',
          message:
            "Deleting the information will not be restored and the digital ID tag will be reset. Scan the code and refill the information to activate the digital ID tag again. ",
        })
        .catch((e) => e);
      if (confirmRes === "confirm") {
        const { data: res } = await this.$http.put("/clear", {
          id: this.petSelectData.id,
        });
        if (res.status !== 200) return this.$toast.fail("Failed to delete");
        this.$toast.success("Deleted");

        this.$router.push({ path: "/home" });
      } else {
        this.$toast.fail("Deletion request is cancelled");
      }
    },
  },
};
</script>

<style scoped>
.van-nav-bar {
  background-color: #1a1a1a;
}
.van-nav-bar__title img {
  padding-top: 5px;
  width: 50px;
}
.van-nav-bar__left img {
  width: 24px;
}
.van-nav-bar__right img {
  width: 24px;
}

.van-tabs--card >>> .van-tabs__wrap {
  height: 44px;
}
.van-tabs >>> .van-tabs__nav--card {
  height: 44px;
  margin: 0;
}
.van-tabs__nav >>> .van-tab {
  height: 44px;
}
.van-tabs--card >>> .van-tabs__nav--card .van-tab.van-tab--active {
  background-color: #ff5349;
}
.van-tabs--card >>> .van-tabs__nav--card .van-tab {
  color: #999 !important;
}
.van-tabs--card >>> .van-tabs__nav--card .van-tab.van-tab--active {
  color: #fff !important;
}
.van-tabs >>> .van-tabs__nav--card {
  border: none !important;
}
.van-tabs >>> .van-tabs__nav--card .van-tab {
  border: none !important;
}
.van-tab >>> .van-tab__text--ellipsis {
  color: #999 !important;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
}
.petinfo-img img {
  width: 100%;
  max-height: 100vw;
  display: block;
}
.van-form {
  position: relative;
}
.van-uploader {
  position: absolute;
  top: 16px;
  right: 17px;
  width: 40px;
  height: 40px;
}
.van-uploader >>> .van-uploader__upload {
  margin: 0;
  height: 40px;
  background: url(../assets/img/pet-info/petinfo-edit-img.png) no-repeat center
    center;
  background-size: 40px 40px;
}
.van-uploader >>> .van-uploader__upload-icon {
  display: none;
}
.petinfo-content {
  width: calc(100% - 32px);
  margin: 0 auto;
  padding-top: 20px;
}

.petinfo-content-title {
  font-size: 24px;
  line-height: 120%;
  font-family: PingFang SC-Regular;
  color: #222;
  padding-bottom: 24px;
}
.petinfo-content-item-title {
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  font-family: Poppins-Regular;
  padding-bottom: 8px;
  color: #666;
}
.van-cell {
  padding: 12px 16px;
  border: 1px solid #e2e2e2;
  margin-bottom: 16px;
  border-radius: 4px;
}
.van-cell--clickable {
  background-color: #f7f8f8;
}
.petinfo-content-age {
  display: flex;
  justify-content: space-between;
}
.petinfo-content-age-year,
.petinfo-content-age-months {
  width: 44vw;
}
.petinfo-content-textarea {
  height: 120px;
}
.petinfo-content-textarea >>> textarea {
  height: 96px !important;
}
.petinfo-save-button {
  padding: 8px 0 28px;
  width: 91.466vw;
  margin: 0 auto;
}
.petinfo-save-button button {
  width: 100%;
  height: 48px;
  border-radius: 48px;
  color: #fff;
  background-color: #ff5349;
  border: none;
}
.ownerinfo-content {
  width: 91.466vw;
  margin: 0 auto;
  padding-top: 20px;
}
.ownerinfo-content-title {
  font-family: Poppins-Medium;
  font-weight: 500;
  font-size: 24px;
  line-height: 120%;
  padding-bottom: 24px;
}
.ownerinfo-content-item-title {
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  font-family: Poppins-Regular;
  color: #666;
  padding-bottom: 8px;
}
.ownerinfo-content-item-address-top {
  margin-bottom: 0;
  border-bottom: 0;
  border-radius: 4px 4px 0px 0px;
}
.ownerinfo-content-item-address-bottom {
  border-radius: 0px 0px 4px 4px;
}
.ownerinfo-content-detailedly {
  display: flex;
  column-gap: 10px;
}

.van-field >>> textarea {
  height: 96px !important;
}
.van-cell >>> .van-field__error-message {
  position: absolute !important;
  top: 0;
}
.petinfo-content-item-title span,
.ownerinfo-content-item-title span {
  color: red;
}
.pw-petinfoshow-new >>> .van-tabs__wrap {
  display: none;
}
.pw-birthday-selects {
  display: flex;
  column-gap: 10px;
}
.pw-petinfo-weight {
  display: flex;
  column-gap: 10px;
}
.ownerinfo-content-detailedly-item {
  width: 100%;
}
.pw-mobile-input >>> input {
  background: url(../assets/img/info/select-icon.png) no-repeat scroll 100%
    center;
}
.cropper-content {
  position: fixed;
  z-index: 9;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
}
.cropper-box-content .vue-cropper {
  background-image: none;
}
.petinfo-upload-icon {
  position: absolute;
  top: 16px;
  right: 17px;
  width: 40px;
  height: 40px;
  background: url(../assets/img/pet-info/petinfo-edit-img.png) no-repeat center
    center;
  background-size: 40px 40px;
}
.petinfo-upload-icon label {
  display: block;
  width: 40px;
  height: 40px;
}
.petinfo-upload-icon input {
  position: absolute;
  width: 40px;
  top: 0;
  height: 40px;
}

/* 裁剪框样式 */
.cropper-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: #000;
}
.cropper-content .cropper-box {
  flex: 1;
  width: 100%;
}
.cropper-content .cropper {
  width: 100vw;
  height: 100vh;
}

.cropper-content .show-preview {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}
.cropper-content .show-preview .preview {
  overflow: hidden;
  border: 1px solid #67c23a;
  background: #cccccc;
}
.cropper-content .footer-btn {
  margin-top: 30px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
}

.footer-btn .upload-btn {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
}

.vue-cropper {
  background-image: none;
}
.upload-btn {
  color: #fff;
}
.upload-btn-cancel {
  position: fixed;
  bottom: 29px;
  left: 20px;
  cursor: pointer;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 125%;
}
.upload-btn-confirm {
  position: fixed;
  bottom: 29px;
  right: 20px;
  cursor: pointer;
  font-family: "Poppins-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 125%;
}

.ownerinfo-content-detailedly-item-state >>> .pw-mobile-input input {
  padding-right: 35px;
}
</style>
